<template>
  <div class="d-flex w-100">
    <b-container fluid class="ui-container">
      <div class="ui-container__header">
        <h1>{{ this.$t(`openToMove.UO.title`) }} </h1>
      </div>

      <b-row>
        <b-col sm="12" md="5">          
          <label class="font-weight-bold">{{$t("openToMove.UO.subtitle")}}</label>
          <input type="text" v-model="unidadOrganizacional"/>
          <div v-if="$v.unidadOrganizacional.$error" class="ui-input-error-msg">{{ $t('global.inputs.required') }}</div>
        </b-col>
        <b-col sm="12" md="3">
          <button class="ui-action-button" :disabled="isSavingUnit" @click="create()">
            {{ $t("openToMove.UO.save") }}
            <b-spinner class="ml-1" small label="loading" v-if="isSavingUnit"></b-spinner>
          </button>
        </b-col>
      </b-row>

      <br/>
      <b-row>
        <div class="col-md-12">
          <v-server-table  :columns="table_options_UO.columns" :options="table_options_UO.options" ref="TableOranizationUnited" id="TableOranizationUnited">
            <template v-slot:action="props">
              <div class="ui-table__action-button"><i class='fas fa-edit' @click="openEditModal(props.row)"></i></div>
            </template>
          </v-server-table>
        </div>
      </b-row>

      <b-modal style="z-index:-1" size="xl" centered ref="Edit_UO" no-close-on-backdrop hide-footer :title="$t('openToMove.UO.editUnit')" tabindex="-1">
        <template #modal-header>
          <div class="ui-modal__header-close-btn">
            <h3>{{$t('openToMove.UO.editUnit')}}</h3>
            <i class='fa fa-times fa-2x' @click="closeEditModal()"></i>
          </div>
        </template>
        <b-container>
          <b-row>
            <b-col sm="3">
                <label class="font-weight-bold">
                  {{ $t("openToMove.UO.subtitle")}}
                </label>
                <input type="text" disabled v-model="currentUnit.ou" />
            </b-col>
            <b-col sm="4">
              <label class="font-weight-bold">
                {{ $t("openToMove.application.tableSUBUO.headings.ouSub")}}
              </label>
              <input type="text" v-model="currentSubUnit.ouSub"/>
              <div v-if="$v.currentSubUnit.ouSub.$error" class="ui-input-error-msg">{{ $t('global.inputs.required') }}</div>
            </b-col>
            <b-col sm="3">
              <label class="font-weight-bold">
                {{ $t("openToMove.application.tableSUBUO.headings.name")}}
              </label>
              <input type="text" v-model="currentSubUnit.name"/>
              <div v-if="$v.currentSubUnit.name.$error" class="ui-input-error-msg">{{ $t('global.inputs.required') }}</div>
            </b-col>
            <b-col sm="2">
              <div class="ui-align-end">
                <button class="ui-action-button" :disabled="isSavingSubUnit" @click="saveSubUnit()">
                  <span>{{ modalActionButtonLabel }}</span>
                  <b-spinner class="ml-1" small label="loading" v-if="isSavingSubUnit"></b-spinner>
                </button>
              </div>
            </b-col>
          </b-row>
          <br/>
          <b-row>
            <b-col sm="12">
              <v-client-table :data="subUnits" :columns="table_options_SUBUO.columns" :options="table_options_SUBUO.options" ref="SubUnidades" id="SubUnidades">
                <template v-slot:action="props">
                  <div class="ui-table__action-button">
                    <i class='fas fa-edit' @click="editSubUO(props.row)"></i>
                  </div>
                </template>
                <template v-slot:status="props">
                  {{ getStatusLabel(props.row) }}
                </template>
              </v-client-table>
            </b-col>
          </b-row>
        </b-container>
      </b-modal>
    </b-container>
  </div>

</template>

<script>
import { required } from "vuelidate/lib/validators";
import API_SERVICE from "@/lib/api/OpenToMove.js";
import { errorCodes, actions, status } from '@/lib/constants';

const api = new API_SERVICE();

export default {
  data() {
    return {
      table_options_UO: {},
      unidadOrganizacional:"",
      subUnits: [],
      currentUnit: {},
      currentSubUnit: {},
      status,
      isSaving: false,
      isSavingUnit: false,
      isSavingSubUnit: false
    };
  },
  beforeMount () {
    this.createTable();
  },
  validations: {
    unidadOrganizacional: {
      required
    },
    currentSubUnit: {
      ouSub: {
        required
      },
      name: {
        required
      }
    }
  },
  computed:{
    TableOranizationUnited: function() {
      return this.$refs.TableOranizationUnited;
    },
    table_UO_columns: function(){
      return [
        "id",
        "ou",
        "action"
      ]
    },
    table_uo_headings: function() {
      if (this.table_UO_columns) {
        const headings = {};
        this.table_UO_columns.forEach(column => {
          headings[column] = this.$t(
            `openToMove.application.tableUO.headings.${column}`
          );
        });
        return headings;
      }
      return null;
    },
    table_filters_UO: function () {
      return this.table_UO_columns.filter((column) => column !== "action");
    },
    table_SUBUO_columns: function(){
      return [
        "id",
        "ouSub",
        "name",
        "action"
      ]
    },
    table_SUBuo_headings: function() {
      if (this.table_SUBUO_columns) {
        const headings = {};
        this.table_SUBUO_columns.forEach(column => {
          headings[column] = this.$t(
            `openToMove.application.tableSUBUO.headings.${column}`
          );
        });
        return headings;
      }
      return null;
    },
    table_filters_SUBUO: function () {
      return this.table_SUBUO_columns.filter((column) => column !== "action");
    },
    table_options_SUBUO: function () {
      return {
        columns: this.table_SUBUO_columns,
        options:
          {
            columnsDropdown: true,
            filterByColumn: true,
            headings: this.table_SUBuo_headings,
            filterable: this.table_filters_SUBUO,
            sortable: [],
            resizableColumns: false,// columnas fijas
            perPage: 25,
            perPageValues: [10, 25, 50, 100],
            columnsClasses: {
              created_at: "created_at",
              period_from: "actions-column",
            },
            texts: {
              filterBy: "{column}",
              columns: this.$t("openToMove.application.tableSUBUO.headings.column_toggler"),
              limit: this.$t("openToMove.application.tableSUBUO.headings.limit")
            },
          },
      };
    },
    isSubUnitEditionActive: function () {
      return Boolean(this.currentSubUnit.id);
    },
    modalActionButtonLabel: function () {
      let label = this.$t("openToMove.UO.addSub")

      if (this.isSubUnitEditionActive) {
        label = this.$t("global.save")
      }

      return label;
    }
  },
  methods:{
    createTable () {
      this.table_options_UO = {
        columns: this.table_UO_columns,
        options: {
            columnsDropdown: true,
            filterByColumn: true,
            headings: this.table_uo_headings,
            filterable: this.table_filters_UO,
            sortable: [],
            resizableColumns: false,// columnas fijas
            perPage: 25,
            perPageValues: [10, 25, 50, 100],
            columnsClasses: {
              created_at: "created_at",
              period_from: "actions-column",
            },
            texts: {
              filterBy: "{column}",
              columns: this.$t("openToMove.application.tableOpenToMove.headings.column_toggler"),
              limit: this.$t("openToMove.application.tableOpenToMove.headings.limit")
            },

            requestAdapter: function (data) {
              const queries = {};
              queries.action = "list"
              queries.pagination = {
                all: false,
                limit: data.limit,
                offset: data.limit * (data.page - 1),
              };
              queries.filter = data.query;
              return queries;

            },
            requestFunction: async function (data) {
              this.$store.commit("global/SET_LOADING", true);
              try {
                const resp = await api.getListUO(data);
                this.$store.commit("global/SET_LOADING", false);
                return resp;
              } catch (error) {
                this.$store.commit("global/SET_LOADING", false);
                this.$store.commit("global/SET_ALERT", {
                  msg: `${error}`,
                  show: true,
                  type: "error"
                });
                throw error;
              }
            },
            responseAdapter: function (response) {
              return {
                data: response.items,
                count: response.total
              };
            }
        }
    };
    },
    closeEditModal(){
      this.currentSubUnit = {};
      this.currentUnit = {};
      this.subUnits = [];
      this.$refs['Edit_UO'].hide();
    },
    async getSubUnits (ouId) {
      const queries = {};
      let items = [];

      queries.action = "list"
      queries.filter = {
        ouId
      }
      queries.pagination = {
        limit: 100
      }

      try {
        const response = await api.querySubs(queries);
        
        if (response && response.data && response.data.items && response.data.items.length) {
          items = response.data.items;
        }

        return items;

      } catch (error) {
        console.error(error);
      }
    },
    openEditModal: async function(data) {
      try {
        this.$store.commit("global/SET_LOADING", true);
        this.currentUnit = data;
        
        this.subUnits = await this.getSubUnits(data.id);

        this.$refs['Edit_UO'].show();
      } catch (error) {
        console.error(error);
        this.currentUnit = {};
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
    create: async function() {
      this.$v.unidadOrganizacional.$touch();
      if (this.$v.unidadOrganizacional.$error) return;

      try {
        this.isSavingUnit = true;
        const queries = {};
        queries.action = "create";
        queries.data = {
          ou: this.unidadOrganizacional
        }

        const resp = await api.createUO(queries);

        if(resp.status === 201) {
            this.unidadOrganizacional = '';
            this.$v.unidadOrganizacional.$reset();
            this.$store.commit("global/SET_LOADING", false);
            this.$store.commit("global/SET_ALERT", {
              msg: this.$t('global.successSaved'),
              show: true,
              type: "success"
            });
            this.TableOranizationUnited.refresh();
        }
      }
      catch (error) {
        console.error(error);
        let errorMessage = this.$t('openToMove.UO.error.save');
        const errorData = error && error.data ? error.data: {};
        const errorType = errorData.error && errorData.error.type ? errorData.error.type : '';
        if (errorType === errorCodes.openToMove.OU_ALREADY_EXISTS ) {
          errorMessage =  this.$t('openToMove.UO.error.alreadyExist');
        }

        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: errorMessage,
          show: true,
          type: "error"
        });
      }
      finally {
        this.isSavingUnit = false;
      }
    },
    saveSubUnit: async function () {
      this.$v.currentSubUnit.$touch();
      if (this.$v.currentSubUnit.$error) return;
      
      this.isSavingSubUnit = true;

      const data = {
        ouId: this.currentUnit.id,
        ouSub: this.currentSubUnit.ouSub,
        name: this.currentSubUnit.name
      };

      try {
        if (this.currentSubUnit.id) { // update
          await api.updateSubUO(data, this.currentSubUnit.id);
          this.subUnits = await this.getSubUnits(this.currentUnit.id);
        } else { // save
          const payload = {
            action: actions.create,
            data
          };
          const response = await api.createSubUO(payload);
          if (response && response.data) {
            this.subUnits.push(response.data);
          }
        }
        this.$v.currentSubUnit.$reset();
        this.currentSubUnit = {};

        this.$store.commit("global/SET_ALERT", {
          msg: this.$t('global.successSaved'),
          show: true,
          type: "success"
        });


      } catch (error) {
        console.error(error);
        let errorMessage = this.$t('openToMove.Sub.error.save');

        const errorData = error && error.data ? error.data: {};
        const errorType = errorData.error && errorData.error.type ? errorData.error.type : '';
        if (errorType === errorCodes.openToMove.SUB_ALREADY_EXISTS ) {
          errorMessage =  this.$t('openToMove.Sub.error.alreadyExist');
        }

        this.$store.commit("global/SET_ALERT", {
          msg: errorMessage,
          show: true,
          type: "error"
        });
      } finally {
        this.isSavingSubUnit = false;
      }
    },
    editSubUO: async function (data) {
      this.currentSubUnit = data;
    },
    getStatusLabel: function (data) {
      return data.status === status.active
        ? this.$t('global.active')
        : this.$t('global.inactive') 
    }
  }
}


</script>

<style lang="scss" scoped>

#SubUnidades .table-responsive {
  height: 300px;
  overflow: auto;
}

</style>

